import { supabase } from '@/lib/integrations/supabase'

export interface AssetHoldingLocation {
  id: string
  unit_id: string
  name: string
  description: string | null
  attrs: Record<string, any>
  active: boolean
  created_at: string
  updated_at: string
}

export interface CreateAssetHoldingLocationInput {
  name: string
  description?: string | null
  attrs?: Record<string, any>
}

export async function listAssetHoldingLocations(unitId: string): Promise<AssetHoldingLocation[]> {
  const { data, error } = await supabase
    .from('asset_holding_locations')
    .select('*')
    .eq('unit_id', unitId)
    .eq('active', true)
    .order('name', { ascending: true })

  if (error) throw error
  return (data ?? []) as AssetHoldingLocation[]
}

export async function createAssetHoldingLocation(
  unitId: string,
  input: CreateAssetHoldingLocationInput,
): Promise<AssetHoldingLocation> {
  const { data, error } = await supabase
    .from('asset_holding_locations')
    .insert({
      unit_id: unitId,
      name: input.name.trim(),
      description: input.description?.trim() || null,
      attrs: input.attrs ?? {},
      active: true,
    })
    .select('*')
    .single()

  if (error || !data) throw error ?? new Error('Failed to create asset holding location')
  return data as AssetHoldingLocation
}
